import useMutationCall from "../../../hooks/useMutationCall";
import { useFinishMutation } from "../checkInSlice";

const useCheckInFinish = () => {
  return useMutationCall(useFinishMutation);
};

export default useCheckInFinish;
